/* eslint-disable @typescript-eslint/naming-convention */
import { useState, cloneElement, useMemo } from "react";

import { PromisifiedDialogContext } from "../context/PromisifiedDialogContext";

interface IPromisifiedDialogProviderProps {
    children: React.ReactNode;
}

type ModalsType = Record<number, React.ReactNode>;

const PromisifiedDialogProvider: React.FC<IPromisifiedDialogProviderProps> = ({
    children,
}: IPromisifiedDialogProviderProps) => {
    const [modals, setModals] = useState<ModalsType>({});

    const setModal = (id: number, modal: React.ReactNode): void => {
        setModals({ ...modals, [id]: modal });
    };

    const removeModal = (id: number): void => {
        const { [id]: _removed, ...rest } = modals;
        setModals(rest);
    };

    const providerValue = useMemo(
        () => ({
            setModal,
            removeModal,
        }),
        []
    );

    const modalArray: React.ReactNode = Object.entries(modals).map(
        ([id, modal]) => {
            return cloneElement(modal as React.ReactElement, {
                key: id,
                id,
                removeModal,
            });
        }
    );

    return (
        <PromisifiedDialogContext.Provider value={providerValue}>
            {children}
            {modalArray}
        </PromisifiedDialogContext.Provider>
    );
};

export default PromisifiedDialogProvider;
